import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import { connect } from "react-redux";
import { handleTableChange } from "../../../../utils/index";
import { 
	getJobRoleRequestList, 
	doJobRoleRequestDelete,
} from "../../../../redux/jobrolerequest/jobRoleRequestState";
import { useSelector } from "react-redux";

const RoleRequestTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
}) => {
	const user = useSelector((state) => state.auth.user);
  	const columns = [
		{
	        title: `Position Title`,
	        dataIndex: 'job_role_title',
	        key: 'job_role_title',
	        width: '30%',
	        render:(job_role_title, record) => <a href={`/console/recruitment-overview/${record.jrr_id}/view`}>
					{job_role_title}
				</a>
	    },
		...(user?.user_level === 3 ? [{
			title: `Client`,
			dataIndex: 'client_name',
			key: 'client_name',
			width: '30%',
			render: (client_name) => <span>{client_name}</span>
		}] : []),
		{
	        title: `Headcount`,
	        dataIndex: 'jrr_count',
	        key: 'jrr_count',
	        width: '10%',
	        render:(jrr_count) => <span>{jrr_count}</span> 
	    },
		{
	        title: `Target Date`,
	        dataIndex: 'jrr_target_date',
	        key: 'jrr_target_date',
	        width: '15%',
	        render:(jrr_target_date) => <span>{jrr_target_date}</span> 
	    },
		{
	        title: `Status`,
	        dataIndex: 'status_name',
	        key: 'status_name',
	        width: '15%',
	        render:(status_name) => <span>{status_name}</span> 
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.jrr_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.jobRoleRequest.jobRoleRequestList?.items,
	pagination: state.jobRoleRequest.jobRoleRequestList?.pagination,
	filters: state.jobRoleRequest.jobRoleRequestList?.filters,
	requesting: state.jobRoleRequest.jobRoleRequestList?.requesting,
	error: state.jobRoleRequest.jobRoleRequestList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getJobRoleRequestList(filters)),
	doDelete: (id) => dispatch(doJobRoleRequestDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleRequestTable);
